module.exports = __webpack_public_path__ + "static/media/Paratiisi-BG-Paradise-300x140.ea4e8d73.png";